export default __webpack_public_path__ + "static/Museo-Sans-700-Italic-2e954f0708a510b45aa9aa6ce03b7d3e.woff2";